// StandAloneEnding.jsx
import React from 'react'
import { withStyles, Typography } from '@material-ui/core'
import { Icon } from '@iconify/react'
import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import styles from './styles'

const StandAloneEnding = props => {
  const { classes } = props
  const history = useHistory()
  const location = useLocation()
  const course = useSelector(state => state.course.course)
  const open = useSelector(state => state.course.sectionDrawerOpen)

  const searchParams = new URLSearchParams(location.search)
  const pageId = searchParams.get('page')
  const isActive = pageId === 'ending'

  const onClickEnding = () => {
    history.push(`/mini-course/${course.id}/page/`)
  }

  return (
    <>
      <div className={classes.FG} />
      <div
        className={`${classes.standAloneEndingDiv} ${
          isActive ? classes.activePage : ''
        }`}
        onClick={onClickEnding}
      >
        <div
          className={classes.contentWrapper}
          style={{
            justifyContent: open ? 'flex-start' : 'center',
          }}
        >
          <Icon icon="mynaui:flag-solid" className={classes.icons} />
          <Typography
            id="ending-page"
            className={classes.pageText}
            style={{
              display: open ? 'block' : 'none',
              width: open ? '100%' : '0%',
            }}
          >
            Customize Completion
          </Typography>
        </div>
      </div>
    </>
  )
}

export default withStyles(styles)(StandAloneEnding)
